import { LOCALES, DEFAULT_LANG, langPrefix } from "@/i18n/locales";
import { HATCH_GEN } from "./hatch_gen";

export function hatchSlug(lang) {
  return (HATCH_GEN[lang] || HATCH_GEN[DEFAULT_LANG] || {}).slug;
}
export function hatchData(lang) {
  return HATCH_GEN[lang] || HATCH_GEN[DEFAULT_LANG] || {};
}
export function hatchPath(lang) {
  return `${langPrefix(lang)}/${hatchSlug(lang)}`;
}
export function buildHatchAlternates(origin) {
  const o = (origin || (typeof window !== "undefined" ? window.location.origin : "")).replace(/\/$/, "");
  const alts = LOCALES.filter((l) => hatchSlug(l.code)).map((l) => ({ hreflang: l.hreflang, href: `${o}${hatchPath(l.code)}` }));
  if (hatchSlug(DEFAULT_LANG)) alts.push({ hreflang: "x-default", href: `${o}${hatchPath(DEFAULT_LANG)}` });
  return alts;
}
export const HATCH_SLUGS = Object.fromEntries(LOCALES.map((l) => [l.code, hatchSlug(l.code)]).filter(([, s]) => s));
